
export default {
  staticDomain: "//static.hsappstatic.net" || window.location.host,
  staticDomainPrefix: "//static.hsappstatic.net" || ('//' + window.location.host),
  currentProject: "marketplace-storefront-public-ui",
  currentProjectVersion: "static-1.13533",
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.13533",
  "apollo-dlb": "static-3.98",
  "breeze-builder-lib": "static-1.1151",
  "client-types": "static-1.512",
  "data-fetching-client": "static-1.10127",
  "foundations-components": "static-1.8769",
  "foundations-components-legacy": "static-1.1794",
  "foundations-theming": "static-1.4978",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.93",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8527",
  "hub-http-shared-msw-handlers": "static-1.10925",
  "hubspot-dlb": "static-2.1911",
  "hubspot-url-utils": "static-1.4383",
  "HubStyleTokens": "static-2.11975",
  "I18n": "static-7.1709",
  "jasmine-runner": "static-1.6941",
  "marketplace-discovery-studio-lib": "static-1.928",
  "marketplace-storefront-base": "static-1.13596",
  "quartz": "static-1.7683",
  "react-dlb": "static-1.94",
  "react-rhumb": "static-1.17227",
  "reactive-variable-buffer-atom": "static-1.3341",
  "reporting-testing-lib": "static-1.11330",
  "reselect": "static-3.16",
  "settings-ui-lib": "static-1.13016",
  "SharedI18nStrings": "static-1.188",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7871",
  "ui-addon-i18n": "static-1.11633",
  "ui-addon-react-router-dom": "static-1.10013",
  "unified-auth": "static-1.1282",
  "unified-auth-core-lib": "static-1.1564",
  "usage-tracker": "static-1.7811",
  "usage-tracker-core": "static-1.7661",
  "customer-data-property-utils": "static-1.8540",
  "hub-http": "static-1.6694",
  "integrations-lib": "static-1.17458",
  "marketplace-ui-common": "static-1.21050",
  "marketplace-ui-install": "static-1.1036",
  "property-management-iframe": "static-1.14482",
  "quartz-config": "static-1.1461",
  "quartz-core": "static-1.6902",
  "quartz-routing": "static-1.1113",
  "quick-fetch": "static-1.4238",
  "react": "static-7.203",
  "rpc-client-utils": "static-1.5157",
  "ts-schema": "static-1.4402",
  "ui-universal-auth": "static-1.9768",
  "UIComponents": "static-3.8921",
  "apollo-stack-hubspot": "static-3.94",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.88",
  "metrics-js": "static-1.9990",
  "react-redux": "static-7.80",
  "redux": "static-4.81",
  "styled-components": "static-2.100",
  "moment": "static-3.75",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3960",
  "quartz-webpack": "static-1.3907",
  "bend-plugin-quartz-routing": "static-1.761",
  "ai-components-ui-library": "static-1.10047",
  "codemirror": "static-5.106",
  "foundations-assets": "static-1.5376",
  "pulse": "static-1.1136",
  "react-codemirror": "static-1.11130",
  "ui-extensions-preview-lib": "static-1.1002",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.5038",
  "floating-ui": "static-1.68",
  "foundations-theming-specialty": "static-1.2694",
  "framer-motion": "static-1.84",
  "hs-story-utils": "static-1.9917",
  "react-aria": "static-1.77",
  "react-create-root-preference": "static-1.105",
  "react-select-plus": "static-1.118",
  "react-utils": "static-2.5667",
  "react-virtualized": "static-2.112",
  "StyleGuideUI": "static-3.518",
  "tanstack-table": "static-1.66",
  "trellis-assets": "static-1.3120",
  "ui-fonts": "static-1.1237",
  "ui-images": "static-2.1278",
  "bend-plugin-foundations-theming": "static-1.3461",
  "foundations-theming-base": "static-1.3963",
  "stylex": "static-1.46",
  "HeadJS": "static-2.824",
  "hs-test-utils-bend-plugin": "static-1.3638",
  "msw": "static-1.103",
  "msw-config": "static-1.30",
  "testing-library": "static-1.165",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.235",
  "moment-timezone": "static-5.96",
  "jasmine": "static-4.4794",
  "ui-addon-video-player": "static-1.9111",
  "ai-rendering-library": "static-1.11424",
  "chirp-fetch": "static-1.2393",
  "connections-embed-lib": "static-1.1778",
  "copilot-toolkit": "static-1.12176",
  "feedback-loader": "static-1.30081",
  "laboratory-lib": "static-3.7635",
  "marketplace-embed": "static-1.23225",
  "marketplace-ui-details": "static-1.10945",
  "marketplace-ui-reviews": "static-1.21005",
  "marketplace-ui-tracking": "static-1.15220",
  "sanitize-text": "static-1.8646",
  "usage-tracker-multi": "static-1.6225",
  "usage-tracker-session-replay": "static-1.5497",
  "beacon-keepalive-queue": "static-1.188",
  "quartz-head": "static-1.1348",
  "web-vitals": "static-1.19",
  "apollo-link-hub-http": "static-2.5077",
  "immer": "static-1.105",
  "immerable": "static-1.4630",
  "highcharts": "static-8.115",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2848",
  "reporting-data": "static-1.69397",
  "cssUtils": "static-1.1111",
  "flux-actions": "static-1.381",
  "react-colorpicker": "static-2.10698",
  "react-dnd-compat": "static-1.5098",
  "redux-observable": "static-1.79",
  "ReduxMessenger": "static-2.10858",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7801",
  "icons": "static-2.704",
  "marketplace-ui-apps-core": "static-1.19582",
  "storybook-react": "static-1.44",
  "trellis-story-utils": "static-1.4986",
  "foundations-components-test-utils": "static-1.6252",
  "quartz-i18n": "static-1.1358",
  "react-input-autosize": "static-2.17",
  "adobe-sign-auth-lib": "static-1.788",
  "ads-unified-auth-lib": "static-1.2034",
  "ai-mcp-auth-lib": "static-1.34",
  "custom-vendor-connection-lib": "static-1.332",
  "gemini-settings-lib": "static-1.9815",
  "google-sheets-integration-lib": "static-1.1357",
  "microsoft-drive-auth-lib": "static-1.571",
  "slack-ui-library": "static-1.10887",
  "surveymonkey-integration-lib": "static-1.893",
  "fsm": "static-1.4246",
  "customer-data-objects": "static-1.8195",
  "property-translator": "static-1.5868",
  "hs-locale-management": "static-1.409",
  "frontend-preferences-client": "static-1.8410",
  "hs-promise-utils": "static-1.6080",
  "hubspot-apollo-client": "static-1.5371",
  "integrations-error-boundary-lib": "static-1.14873",
  "integrations-tracking-lib": "static-1.6111",
  "native-integrations-shared-strings": "static-1.8251",
  "sanitize": "static-1.4963",
  "superstore": "static-1.5247",
  "ui-shepherd-react": "static-3.10768",
  "ai-settings-ui-library": "static-1.8615",
  "hub-http-janus": "static-1.908",
  "hubspotter-http": "static-1.4982",
  "immutable-less": "static-1.5140",
  "marketplace-ui-client-types": "static-1.18457",
  "nav-meta": "static-1.30834",
  "react-window": "static-1.13",
  "ui-addon-upgrades": "static-9.18554",
  "ui-product-approvals-common": "static-1.1614",
  "ai-studio-lib": "static-1.12796",
  "hubspot-prosemirror": "static-1.19306",
  "integrations-reconnect-lib": "static-1.751",
  "ui-addon-iframeable": "static-1.9566",
  "ui-addon-integrations-directory-panel": "static-2.8442",
  "ui-product-approvals": "static-1.29719",
  "ui-tool-access": "static-1.10646",
  "inbound-db-properties-service-client": "static-1.4158",
  "property-management-common": "static-1.6770",
  "opentelemetry-fe-types": "static-1.279",
  "dispatcher": "static-1.148",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.607",
  "module-federation": "static-1.39",
  "opentelemetry-fe": "static-1.654",
  "quartz-auth": "static-1.1358",
  "quartz-test": "static-1.1358",
  "quartz-tracking": "static-1.1062",
  "trellis-components": "static-1.3139",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.567",
  "HubStyle": "static-2.12282",
  "bender-build-tools": "static-1.3604",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.23963",
  "ContentUtils": "static-1.69507",
  "customer-data-objects-ui-components": "static-1.13524",
  "sassPrefix": "static-1.376",
  "diff-match-patch": "static-1.7",
  "batch-promise": "static-1.2037",
  "bend-plugin-pulse": "static-1.639",
  "event-emitter": "static-1.1450",
  "fast-json-patch": "static-1.74",
  "browser-eslint": "static-2.57",
  "magpie-lib": "static-1.5918",
  "magpie-types": "static-1.5378",
  "stylex-utils": "static-1.176",
  "trellis-theming": "static-1.1502",
  "avatar-components": "static-1.2975",
  "breeze-engine-core": "static-1.1510",
  "breeze-engine-lib": "static-1.2232",
  "breeze-onboarding-components": "static-1.1092",
  "customer-data-filters-ui": "static-1.41413",
  "customer-data-reference-ui-components": "static-1.13662",
  "data-integrations-breeze": "static-1.354",
  "embedded-academy-lib": "static-1.16043",
  "ExportDialog": "static-6.10861",
  "global-styles-ai-lib": "static-1.517",
  "highlight.js": "static-1.90",
  "marketplace-embed-ba": "static-1.928",
  "markdown-it": "static-1.6",
  "mermaid": "static-1.45",
  "reporting-action-components": "static-1.42432",
  "reporting-snowflake": "static-1.58013",
  "reporting-ui-components": "static-2.66666",
  "reporting-visualizations": "static-1.61471",
  "trial-components-library": "static-1.14403",
  "ui-addon-teams": "static-1.22026",
  "upgrade-components-lib": "static-1.743",
  "navigation-components": "static-1.19197",
  "nest": "static-1.724",
  "simple-logging-lib": "static-1.3539",
  "nudge-client-utils": "static-1.3444",
  "fail-safe": "static-1.438",
  "app-governance-lib": "static-1.2766",
  "developer-experience-shared-components": "static-1.11029",
  "purchase-motions-components": "static-1.6650",
  "transmute": "static-2.97",
  "usage-based-billing-components-lib": "static-1.10817",
  "usage-tracker-anonymous": "static-1.6228",
  "usage-tracker-public": "static-1.7622",
  "amplitude-session-replay-browser": "static-1.60",
  "inbound-db-meta-service-client": "static-1.3782",
  "persist-promise": "static-1.4194",
  "reference-resolvers": "static-1.8672",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "ui-extensibility-client-types": "static-1.4403",
  "hubspot-apollo-cache": "static-1.830",
  "universal-page-editor-lib": "static-1.3501",
  "final-form": "static-1.83",
  "redux-toolkit": "static-1.82",
  "simple-data-table": "static-1.3847",
  "merchandise-lib": "static-1.286",
  "onboarding-scopes": "static-1.6942",
  "ui-addon-draggable": "static-3.5237",
  "content-assistance-lib": "static-1.8442",
  "content-media-capture": "static-1.5817",
  "customer-data-ui-utilities": "static-1.10320",
  "emoji-mart": "static-3.7",
  "file-manager-components": "static-1.24861",
  "growth-payments-core": "static-1.26527",
  "knowledge-content-types": "static-1.8767",
  "PatternValidationJS": "static-1.3372",
  "payment-link-components": "static-1.24482",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.20575",
  "ui-addon-emoji-picker": "static-1.10351",
  "ui-business-units-lib": "static-1.9585",
  "video-components-external": "static-1.12467",
  "video-data-lib": "static-1.36125",
  "navigation-messaging": "static-1.8524",
  "collaboration-sidebar": "static-1.59085",
  "trellis-ext-dnd": "static-1.564",
  "crm-component-utils": "static-1.40221",
  "crm-properties-common-lib": "static-1.6385",
  "customer-data-properties": "static-1.53096",
  "external-options-client-types": "static-1.4446",
  "hs-resources": "static-1.672",
  "property-value-citations": "static-1.3710",
  "reference-resolvers-lite": "static-1.8601",
  "opentelemetry-web": "static-1.23",
  "hubspotter-http-shared-msw-handlers": "static-1.10923",
  "base-ui": "static-1.29",
  "react-day-picker": "static-1.15",
  "tanstack-virtual": "static-1.43",
  "cms-field-types": "static-1.5298",
  "content-icons-ui": "static-1.2470",
  "atom": "static-1.5560",
  "idb-keyval": "static-1.55",
  "reactive-lib": "static-1.1209",
  "trellis-migration-context": "static-1.69",
  "ably": "static-2.2",
  "breeze-engine-chat-components": "static-1.1210",
  "breeze-artifacts-sdk": "static-1.1027",
  "getting-started-shared-tasks": "static-1.19588",
  "onboarding-journeys-lib": "static-1.1255",
  "conversations-skeleton-state": "static-1.7609",
  "crm-message-bus": "static-1.44137",
  "customer-data-filters-ui-msw-helpers": "static-1.23848",
  "events-data-lib": "static-1.735",
  "FormUrlGenerator": "static-2.5202",
  "framework-builder-read-service-client": "static-1.4342",
  "multi-account-reference-resolvers": "static-1.1500",
  "onboarding-tours": "static-1.17411",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.14792",
  "segments-client-types": "static-1.12209",
  "academy-common-lib": "static-1.15504",
  "dashboard-lib": "static-1.83334",
  "hubspot-prosemirror-plugins": "static-1.19298",
  "share-with-third-party-component-lib": "static-1.9200",
  "ui-asset-management-lib": "static-1.11589",
  "user-context": "static-1.5542",
  "reporting-plugins": "static-1.11013",
  "reporting-reports": "static-1.69073",
  "hubs-service-types": "static-1.1756",
  "purchase-motions-api": "static-1.6653",
  "salesImages": "static-1.746",
  "signup-constants": "static-1.19970",
  "nudge-custom-function-registry": "static-1.3201",
  "nudge-renderer-utils": "static-1.3520",
  "whisper-core-api": "static-1.7662",
  "bend-plugin-fail-safe": "static-1.389",
  "framework-listing-lib": "static-2.29838",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.31776",
  "apps-service-types": "static-1.4096",
  "oauth-service-types": "static-1.4625",
  "signup-ui-url-generator": "static-2.8526",
  "onboarding-tours-client": "static-1.5626",
  "one-click-checkout": "static-1.762",
  "platform-infra-nav-components": "static-1.8009",
  "subscription-experience-data-types": "static-1.15454",
  "crm-record-cards-client": "static-1.84",
  "crm-record-cards-service-types": "static-1.3871",
  "framework-data-schema-resolvers": "static-1.7381",
  "location-customization-utils-lib": "static-1.10446",
  "redux-thunk": "static-2.84",
  "react-flip-move": "static-1.83",
  "ui-coaching-tips": "static-1.29597",
  "content-media-composition-data-lib": "static-1.13621",
  "fix-webm-duration": "static-1.34",
  "notification-sounds": "static-1.4917",
  "react-immutable-render-mixin": "static-1.9",
  "poll-commands": "static-1.3966",
  "seat-types-lib": "static-1.1070",
  "ui-addon-opt": "static-4.8901",
  "commerce-tours-lib": "static-1.6881",
  "growth-onboarding-reliability": "static-1.5572",
  "sales-checkout-service-client": "static-1.4009",
  "data-token-picker": "static-1.17155",
  "FileManagerLib": "static-1.40501",
  "content-media-compositions": "static-2.17628",
  "media-bridge-lib": "static-1.19662",
  "chatspot-widget-iframe": "static-1.23954",
  "collaboration-sidebar-common": "static-1.3882",
  "marketing-platform-lib": "static-1.7394",
  "dnd-kit": "static-1.21",
  "commerce-subscription-lib": "static-1.38080",
  "crm-actions": "static-1.6868",
  "crm-cards-sdk": "static-1.45055",
  "customer-data-properties-shared-msw-handlers": "static-1.10252",
  "customer-data-tracking": "static-1.7360",
  "calling-global-api": "static-1.66230",
  "calling-internal-common": "static-1.31813",
  "calling-lifecycle-internal": "static-1.67612",
  "calling-lifecycle-messages": "static-1.59904",
  "commerce-products-lib": "static-1.10942",
  "conditional-properties-service-client": "static-1.4120",
  "crm-index-visualization-core": "static-1.4776",
  "crm-links": "static-1.6801",
  "crm-pipelines-api-client-types": "static-1.4451",
  "data-agent-utils": "static-1.955",
  "formula-editor": "static-1.15028",
  "google-libphonenumber": "static-1.50",
  "inbounddb-objects-service-types": "static-1.4522",
  "meetings-icalendar-utils-lib": "static-1.1120",
  "multi-currency-client-types": "static-1.4015",
  "object-builder-ui-client": "static-1.50080",
  "pipeline-validation-client-types": "static-1.4290",
  "smart-data-capture-core": "static-1.510",
  "smart-property-lib": "static-1.8687",
  "tiered-pricing": "static-1.2305",
  "topics-actions-lib": "static-1.672",
  "trellis-ext-i18n": "static-1.1408",
  "ui-addon-form-validation": "static-1.11348",
  "zustand": "static-1.89",
  "fdsr-migration-layer": "static-1.500",
  "restore-request-side-panel-lib": "static-1.2052",
  "growth-data-modal": "static-1.6155",
  "growth-onboarding-confetti": "static-1.3546",
  "growth-onboarding-next-action-utils": "static-1.3009",
  "onboarding-tours-utils": "static-1.1478",
  "ui-shepherd-tracker": "static-1.8149",
  "crm-index-associations-lib": "static-1.6936",
  "academy-service-client": "static-1.4180",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.40360",
  "SafeStorage": "static-1.4885",
  "video-embed": "static-1.36959",
  "wootric-nps": "static-1.7305",
  "redux-actions": "static-3.74",
  "EmailSignatureEditor": "static-1.25272",
  "viral-links-lib": "static-1.7571",
  "nested-table": "static-1.720",
  "timezone-utils": "static-2.5719",
  "getting-started-shared-tasks-store": "static-1.18706",
  "campaign-roi-lib": "static-1.10860",
  "campaigns-utils-lib": "static-1.3738",
  "ui-addon-calendars": "static-2.5854",
  "customer-data-views-management": "static-1.26381",
  "framework-data-table": "static-2.12861",
  "nudge-custom-ui-functions": "static-1.1760",
  "switchboard-lib": "static-1.725",
  "access-check-ui-lib": "static-1.1907",
  "app-users-service-client": "static-1.6109",
  "app-users-service-types": "static-1.5517",
  "mini-checkout-client": "static-1.27857",
  "onboarding-utils": "static-1.5862",
  "permissions-shared-i18n-strings-fe": "static-1.2143",
  "ui-coaching-tips-shared-config": "static-1.29582",
  "checkout-sdk": "static-3.24700",
  "payment-method-components": "static-1.7332",
  "touchless-buying-components": "static-1.6568",
  "upgrade-catalog-service-types": "static-1.3902",
  "edison-service-client-types": "static-1.880",
  "framework-data-schema-quick-fetch": "static-1.7286",
  "growth-onboarding-feedback-components": "static-1.7069",
  "audio-components": "static-1.6592",
  "FileManagerImages": "static-1.38012",
  "video-components": "static-1.14469",
  "js-cookie": "static-1.18",
  "commerce-billing-lib": "static-1.20519",
  "commerce-shared-components-lib": "static-1.19597",
  "commerce-tools-ui-lib": "static-1.11345",
  "crm_data": "static-4.93232",
  "crm-activity-creator-data": "static-1.47768",
  "crm-fe-perf": "static-1.23387",
  "universal-record-utils-lib": "static-1.2393",
  "calling-error-reporting": "static-1.31820",
  "shared-worker-versioning": "static-1.11532",
  "calling-usage-tracker": "static-1.7029",
  "voice-sms-access-library": "static-1.2491",
  "commerce-permissions": "static-1.1274",
  "products-iframe-lib": "static-1.8942",
  "products-ui-components-shared-msw-handlers": "static-1.11307",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.11008",
  "sales-views-client-types": "static-1.4747",
  "data-agent-kit": "static-1.942",
  "enrichment-settings-lib": "static-1.257",
  "policy-lib": "static-1.7292",
  "bark-lib": "static-1.17022",
  "browser-prettier": "static-1.11",
  "data-agent-test-utils": "static-1.486",
  "react-tinymce": "static-1.56290",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.11071",
  "tinymce-config": "static-2.55416",
  "tinymce-plugins": "static-1.58530",
  "onboarding-data-sync-lib": "static-1.2859",
  "growth-onboarding-next-action-components": "static-1.3037",
  "user-context-client": "static-1.4998",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.65",
  "urlinator": "static-1.5002",
  "outpost": "static-1.4617",
  "draft-convert": "static-2.84",
  "draft-extend": "static-3.88",
  "draft-js": "static-5.90",
  "draft-plugins": "static-2.22379",
  "sales-email-signature-service-client": "static-1.4337",
  "ts-utils-lib": "static-1.640",
  "copilot-messaging": "static-1.2426",
  "crm-export-dialog": "static-1.6766",
  "crm-index-ui-shimmer": "static-1.3002",
  "crm-view-components": "static-1.1522",
  "react-beautiful-dnd": "static-1.75",
  "customer-data-associations": "static-1.7826",
  "tasks-actions-lib": "static-1.459",
  "InboxConnectUtils": "static-4.15866",
  "emoji-regex": "static-1.7",
  "hub-http-rxjs": "static-1.881",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "billing-payments-client-types": "static-1.4475",
  "company-details-components": "static-1.6694",
  "react-performance-metrics-lib": "static-1.1041",
  "pricing-pages-ui-components": "static-1.16630",
  "quote-checkout-service-types": "static-1.3948",
  "social-insights-client-types": "static-1.22954",
  "utility-belt": "static-1.3026",
  "payments-enrollment-embed-lib": "static-1.24241",
  "stripe-embedded-components": "static-1.8267",
  "customer-data-rte": "static-1.33925",
  "cv-backend-services": "static-1.1607",
  "growth-onboarding-empty-states": "static-1.6555",
  "payments-post-enroll-local-storage-lib": "static-1.5594",
  "qrcode-generator": "static-1.80",
  "quotes-client-types": "static-1.39195",
  "crm_universal": "static-1.22746",
  "customer-data-email": "static-1.18662",
  "meetings-rte-lib": "static-1.565",
  "universal-associations-select": "static-1.11585",
  "crm-object-search-query-utilities": "static-1.10484",
  "calling-orchestration-schema": "static-1.37268",
  "react-reducer-toolkit": "static-1.16691",
  "tinymce": "static-5.11",
  "tinymce-themes": "static-1.57386",
  "hub-http-contrib": "static-1.3521",
  "interframe": "static-3.5230",
  "tinymce-data": "static-1.41501",
  "ui-addon-sales-email": "static-1.5690",
  "layout-dnd-components": "static-1.13247",
  "layout-dnd-utils": "static-1.12222",
  "ui-brand-identity-lib": "static-1.16984",
  "meetings-connect-utils-lib": "static-1.8108",
  "company-details-service-types": "static-1.4433",
  "segments-query-core": "static-1.1919",
  "pricing-pages-api": "static-1.16495",
  "stripe-connect-js": "static-1.83",
  "draft-content-plugins": "static-1.29178",
  "sequences-lib": "static-1.8808",
  "ui-gdpr-components": "static-1.10656",
  "meetings-client-types": "static-1.4079",
  "meetings-core": "static-1.787",
  "NamespacedHubStyle": "static-2.9375",
  "ContentData": "static-1.69582",
  "layout-data-lib": "static-1.10547",
  "sequences-client-types-lib": "static-1.8665",
  "advanced-menus-core": "static-1.15837",
  "advanced-menus-lib": "static-1.12584",
  "ui-memberships-settings-lib": "static-1.35227",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15836",
  "simple-menus-lib": "static-1.17353"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.13533",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "breeze-builder-lib": "/breeze-builder-lib/static-1.1151",
  "client-types": "/client-types/static-1.512",
  "data-fetching-client": "/data-fetching-client/static-1.10127",
  "foundations-components": "/foundations-components/static-1.8769",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1794",
  "foundations-theming": "/foundations-theming/static-1.4978",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.93",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8527",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10925",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "HubStyleTokens": "/HubStyleTokens/static-2.11975",
  "I18n": "/I18n/static-7.1709",
  "jasmine-runner": "/jasmine-runner/static-1.6941",
  "marketplace-discovery-studio-lib": "/marketplace-discovery-studio-lib/static-1.928",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.13596",
  "quartz": "/quartz/static-1.7683",
  "react-dlb": "/react-dlb/static-1.94",
  "react-rhumb": "/react-rhumb/static-1.17227",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.3341",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.11330",
  "reselect": "/reselect/static-3.16",
  "settings-ui-lib": "/settings-ui-lib/static-1.13016",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.188",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7871",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11633",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.10013",
  "unified-auth": "/unified-auth/static-1.1282",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1564",
  "usage-tracker": "/usage-tracker/static-1.7811",
  "usage-tracker-core": "/usage-tracker-core/static-1.7661",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8540",
  "hub-http": "/hub-http/static-1.6694",
  "integrations-lib": "/integrations-lib/static-1.17458",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.21050",
  "marketplace-ui-install": "/marketplace-ui-install/static-1.1036",
  "property-management-iframe": "/property-management-iframe/static-1.14482",
  "quartz-config": "/quartz-config/static-1.1461",
  "quartz-core": "/quartz-core/static-1.6902",
  "quartz-routing": "/quartz-routing/static-1.1113",
  "quick-fetch": "/quick-fetch/static-1.4238",
  "react": "/react/static-7.203",
  "rpc-client-utils": "/rpc-client-utils/static-1.5157",
  "ts-schema": "/ts-schema/static-1.4402",
  "ui-universal-auth": "/ui-universal-auth/static-1.9768",
  "UIComponents": "/UIComponents/static-3.8921",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.94",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.88",
  "metrics-js": "/metrics-js/static-1.9990",
  "react-redux": "/react-redux/static-7.80",
  "redux": "/redux/static-4.81",
  "styled-components": "/styled-components/static-2.100",
  "moment": "/moment/static-3.75",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3960",
  "quartz-webpack": "/quartz-webpack/static-1.3907",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.761",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.10047",
  "codemirror": "/codemirror/static-5.106",
  "foundations-assets": "/foundations-assets/static-1.5376",
  "pulse": "/pulse/static-1.1136",
  "react-codemirror": "/react-codemirror/static-1.11130",
  "ui-extensions-preview-lib": "/ui-extensions-preview-lib/static-1.1002",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.5038",
  "floating-ui": "/floating-ui/static-1.68",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2694",
  "framer-motion": "/framer-motion/static-1.84",
  "hs-story-utils": "/hs-story-utils/static-1.9917",
  "react-aria": "/react-aria/static-1.77",
  "react-create-root-preference": "/react-create-root-preference/static-1.105",
  "react-select-plus": "/react-select-plus/static-1.118",
  "react-utils": "/react-utils/static-2.5667",
  "react-virtualized": "/react-virtualized/static-2.112",
  "StyleGuideUI": "/StyleGuideUI/static-3.518",
  "tanstack-table": "/tanstack-table/static-1.66",
  "trellis-assets": "/trellis-assets/static-1.3120",
  "ui-fonts": "/ui-fonts/static-1.1237",
  "ui-images": "/ui-images/static-2.1278",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3461",
  "foundations-theming-base": "/foundations-theming-base/static-1.3963",
  "stylex": "/stylex/static-1.46",
  "HeadJS": "/HeadJS/static-2.824",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3638",
  "msw": "/msw/static-1.103",
  "msw-config": "/msw-config/static-1.30",
  "testing-library": "/testing-library/static-1.165",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.235",
  "moment-timezone": "/moment-timezone/static-5.96",
  "jasmine": "/jasmine/static-4.4794",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9111",
  "ai-rendering-library": "/ai-rendering-library/static-1.11424",
  "chirp-fetch": "/chirp-fetch/static-1.2393",
  "connections-embed-lib": "/connections-embed-lib/static-1.1778",
  "copilot-toolkit": "/copilot-toolkit/static-1.12176",
  "feedback-loader": "/feedback-loader/static-1.30081",
  "laboratory-lib": "/laboratory-lib/static-3.7635",
  "marketplace-embed": "/marketplace-embed/static-1.23225",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.10945",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.21005",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.15220",
  "sanitize-text": "/sanitize-text/static-1.8646",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.6225",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5497",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.188",
  "quartz-head": "/quartz-head/static-1.1348",
  "web-vitals": "/web-vitals/static-1.19",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5077",
  "immer": "/immer/static-1.105",
  "immerable": "/immerable/static-1.4630",
  "highcharts": "/highcharts/static-8.115",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2848",
  "reporting-data": "/reporting-data/static-1.69397",
  "cssUtils": "/cssUtils/static-1.1111",
  "flux-actions": "/flux-actions/static-1.381",
  "react-colorpicker": "/react-colorpicker/static-2.10698",
  "react-dnd-compat": "/react-dnd-compat/static-1.5098",
  "redux-observable": "/redux-observable/static-1.79",
  "ReduxMessenger": "/ReduxMessenger/static-2.10858",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7801",
  "icons": "/icons/static-2.704",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19582",
  "storybook-react": "/storybook-react/static-1.44",
  "trellis-story-utils": "/trellis-story-utils/static-1.4986",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6252",
  "quartz-i18n": "/quartz-i18n/static-1.1358",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.788",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.2034",
  "ai-mcp-auth-lib": "/ai-mcp-auth-lib/static-1.34",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.332",
  "gemini-settings-lib": "/gemini-settings-lib/static-1.9815",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1357",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.571",
  "slack-ui-library": "/slack-ui-library/static-1.10887",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.893",
  "fsm": "/fsm/static-1.4246",
  "customer-data-objects": "/customer-data-objects/static-1.8195",
  "property-translator": "/property-translator/static-1.5868",
  "hs-locale-management": "/hs-locale-management/static-1.409",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8410",
  "hs-promise-utils": "/hs-promise-utils/static-1.6080",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5371",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14873",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6111",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8251",
  "sanitize": "/sanitize/static-1.4963",
  "superstore": "/superstore/static-1.5247",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10768",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8615",
  "hub-http-janus": "/hub-http-janus/static-1.908",
  "hubspotter-http": "/hubspotter-http/static-1.4982",
  "immutable-less": "/immutable-less/static-1.5140",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18457",
  "nav-meta": "/nav-meta/static-1.30834",
  "react-window": "/react-window/static-1.13",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18554",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1614",
  "ai-studio-lib": "/ai-studio-lib/static-1.12796",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.19306",
  "integrations-reconnect-lib": "/integrations-reconnect-lib/static-1.751",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9566",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8442",
  "ui-product-approvals": "/ui-product-approvals/static-1.29719",
  "ui-tool-access": "/ui-tool-access/static-1.10646",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4158",
  "property-management-common": "/property-management-common/static-1.6770",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.279",
  "dispatcher": "/dispatcher/static-1.148",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.607",
  "module-federation": "/module-federation/static-1.39",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.654",
  "quartz-auth": "/quartz-auth/static-1.1358",
  "quartz-test": "/quartz-test/static-1.1358",
  "quartz-tracking": "/quartz-tracking/static-1.1062",
  "trellis-components": "/trellis-components/static-1.3139",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.567",
  "HubStyle": "/HubStyle/static-2.12282",
  "bender-build-tools": "/bender-build-tools/static-1.3604",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.23963",
  "ContentUtils": "/ContentUtils/static-1.69507",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13524",
  "sassPrefix": "/sassPrefix/static-1.376",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "batch-promise": "/batch-promise/static-1.2037",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.639",
  "event-emitter": "/event-emitter/static-1.1450",
  "fast-json-patch": "/fast-json-patch/static-1.74",
  "browser-eslint": "/browser-eslint/static-2.57",
  "magpie-lib": "/magpie-lib/static-1.5918",
  "magpie-types": "/magpie-types/static-1.5378",
  "stylex-utils": "/stylex-utils/static-1.176",
  "trellis-theming": "/trellis-theming/static-1.1502",
  "avatar-components": "/avatar-components/static-1.2975",
  "breeze-engine-core": "/breeze-engine-core/static-1.1510",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.2232",
  "breeze-onboarding-components": "/breeze-onboarding-components/static-1.1092",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.41413",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13662",
  "data-integrations-breeze": "/data-integrations-breeze/static-1.354",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.16043",
  "ExportDialog": "/ExportDialog/static-6.10861",
  "global-styles-ai-lib": "/global-styles-ai-lib/static-1.517",
  "highlight.js": "/highlight.js/static-1.90",
  "marketplace-embed-ba": "/marketplace-embed-ba/static-1.928",
  "markdown-it": "/markdown-it/static-1.6",
  "mermaid": "/mermaid/static-1.45",
  "reporting-action-components": "/reporting-action-components/static-1.42432",
  "reporting-snowflake": "/reporting-snowflake/static-1.58013",
  "reporting-ui-components": "/reporting-ui-components/static-2.66666",
  "reporting-visualizations": "/reporting-visualizations/static-1.61471",
  "trial-components-library": "/trial-components-library/static-1.14403",
  "ui-addon-teams": "/ui-addon-teams/static-1.22026",
  "upgrade-components-lib": "/upgrade-components-lib/static-1.743",
  "navigation-components": "/navigation-components/static-1.19197",
  "nest": "/nest/static-1.724",
  "simple-logging-lib": "/simple-logging-lib/static-1.3539",
  "nudge-client-utils": "/nudge-client-utils/static-1.3444",
  "fail-safe": "/fail-safe/static-1.438",
  "app-governance-lib": "/app-governance-lib/static-1.2766",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.11029",
  "purchase-motions-components": "/purchase-motions-components/static-1.6650",
  "transmute": "/transmute/static-2.97",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.10817",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6228",
  "usage-tracker-public": "/usage-tracker-public/static-1.7622",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3782",
  "persist-promise": "/persist-promise/static-1.4194",
  "reference-resolvers": "/reference-resolvers/static-1.8672",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4403",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.830",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3501",
  "final-form": "/final-form/static-1.83",
  "redux-toolkit": "/redux-toolkit/static-1.82",
  "simple-data-table": "/simple-data-table/static-1.3847",
  "merchandise-lib": "/merchandise-lib/static-1.286",
  "onboarding-scopes": "/onboarding-scopes/static-1.6942",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5237",
  "content-assistance-lib": "/content-assistance-lib/static-1.8442",
  "content-media-capture": "/content-media-capture/static-1.5817",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10320",
  "emoji-mart": "/emoji-mart/static-3.7",
  "file-manager-components": "/file-manager-components/static-1.24861",
  "growth-payments-core": "/growth-payments-core/static-1.26527",
  "knowledge-content-types": "/knowledge-content-types/static-1.8767",
  "PatternValidationJS": "/PatternValidationJS/static-1.3372",
  "payment-link-components": "/payment-link-components/static-1.24482",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.20575",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10351",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9585",
  "video-components-external": "/video-components-external/static-1.12467",
  "video-data-lib": "/video-data-lib/static-1.36125",
  "navigation-messaging": "/navigation-messaging/static-1.8524",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.59085",
  "trellis-ext-dnd": "/trellis-ext-dnd/static-1.564",
  "crm-component-utils": "/crm-component-utils/static-1.40221",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6385",
  "customer-data-properties": "/customer-data-properties/static-1.53096",
  "external-options-client-types": "/external-options-client-types/static-1.4446",
  "hs-resources": "/hs-resources/static-1.672",
  "property-value-citations": "/property-value-citations/static-1.3710",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8601",
  "opentelemetry-web": "/opentelemetry-web/static-1.23",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10923",
  "base-ui": "/base-ui/static-1.29",
  "react-day-picker": "/react-day-picker/static-1.15",
  "tanstack-virtual": "/tanstack-virtual/static-1.43",
  "cms-field-types": "/cms-field-types/static-1.5298",
  "content-icons-ui": "/content-icons-ui/static-1.2470",
  "atom": "/atom/static-1.5560",
  "idb-keyval": "/idb-keyval/static-1.55",
  "reactive-lib": "/reactive-lib/static-1.1209",
  "trellis-migration-context": "/trellis-migration-context/static-1.69",
  "ably": "/ably/static-2.2",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.1210",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.1027",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19588",
  "onboarding-journeys-lib": "/onboarding-journeys-lib/static-1.1255",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7609",
  "crm-message-bus": "/crm-message-bus/static-1.44137",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23848",
  "events-data-lib": "/events-data-lib/static-1.735",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.5202",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4342",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1500",
  "onboarding-tours": "/onboarding-tours/static-1.17411",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14792",
  "segments-client-types": "/segments-client-types/static-1.12209",
  "academy-common-lib": "/academy-common-lib/static-1.15504",
  "dashboard-lib": "/dashboard-lib/static-1.83334",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.19298",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.9200",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11589",
  "user-context": "/user-context/static-1.5542",
  "reporting-plugins": "/reporting-plugins/static-1.11013",
  "reporting-reports": "/reporting-reports/static-1.69073",
  "hubs-service-types": "/hubs-service-types/static-1.1756",
  "purchase-motions-api": "/purchase-motions-api/static-1.6653",
  "salesImages": "/salesImages/static-1.746",
  "signup-constants": "/signup-constants/static-1.19970",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3201",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3520",
  "whisper-core-api": "/whisper-core-api/static-1.7662",
  "bend-plugin-fail-safe": "/bend-plugin-fail-safe/static-1.389",
  "framework-listing-lib": "/framework-listing-lib/static-2.29838",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.31776",
  "apps-service-types": "/apps-service-types/static-1.4096",
  "oauth-service-types": "/oauth-service-types/static-1.4625",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8526",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5626",
  "one-click-checkout": "/one-click-checkout/static-1.762",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.8009",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15454",
  "crm-record-cards-client": "/crm-record-cards-client/static-1.84",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3871",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7381",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10446",
  "redux-thunk": "/redux-thunk/static-2.84",
  "react-flip-move": "/react-flip-move/static-1.83",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29597",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13621",
  "fix-webm-duration": "/fix-webm-duration/static-1.34",
  "notification-sounds": "/notification-sounds/static-1.4917",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "poll-commands": "/poll-commands/static-1.3966",
  "seat-types-lib": "/seat-types-lib/static-1.1070",
  "ui-addon-opt": "/ui-addon-opt/static-4.8901",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6881",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5572",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.4009",
  "data-token-picker": "/data-token-picker/static-1.17155",
  "FileManagerLib": "/FileManagerLib/static-1.40501",
  "content-media-compositions": "/content-media-compositions/static-2.17628",
  "media-bridge-lib": "/media-bridge-lib/static-1.19662",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.23954",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.3882",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.7394",
  "dnd-kit": "/dnd-kit/static-1.21",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.38080",
  "crm-actions": "/crm-actions/static-1.6868",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.45055",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.10252",
  "customer-data-tracking": "/customer-data-tracking/static-1.7360",
  "calling-global-api": "/calling-global-api/static-1.66230",
  "calling-internal-common": "/calling-internal-common/static-1.31813",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67612",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59904",
  "commerce-products-lib": "/commerce-products-lib/static-1.10942",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4120",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4776",
  "crm-links": "/crm-links/static-1.6801",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4451",
  "data-agent-utils": "/data-agent-utils/static-1.955",
  "formula-editor": "/formula-editor/static-1.15028",
  "google-libphonenumber": "/google-libphonenumber/static-1.50",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4522",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.1120",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.4015",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.50080",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4290",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.510",
  "smart-property-lib": "/smart-property-lib/static-1.8687",
  "tiered-pricing": "/tiered-pricing/static-1.2305",
  "topics-actions-lib": "/topics-actions-lib/static-1.672",
  "trellis-ext-i18n": "/trellis-ext-i18n/static-1.1408",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11348",
  "zustand": "/zustand/static-1.89",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.500",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.2052",
  "growth-data-modal": "/growth-data-modal/static-1.6155",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3546",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.3009",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1478",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8149",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6936",
  "academy-service-client": "/academy-service-client/static-1.4180",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.40360",
  "SafeStorage": "/SafeStorage/static-1.4885",
  "video-embed": "/video-embed/static-1.36959",
  "wootric-nps": "/wootric-nps/static-1.7305",
  "redux-actions": "/redux-actions/static-3.74",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.25272",
  "viral-links-lib": "/viral-links-lib/static-1.7571",
  "nested-table": "/nested-table/static-1.720",
  "timezone-utils": "/timezone-utils/static-2.5719",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18706",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.10860",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3738",
  "ui-addon-calendars": "/ui-addon-calendars/static-2.5854",
  "customer-data-views-management": "/customer-data-views-management/static-1.26381",
  "framework-data-table": "/framework-data-table/static-2.12861",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1760",
  "switchboard-lib": "/switchboard-lib/static-1.725",
  "access-check-ui-lib": "/access-check-ui-lib/static-1.1907",
  "app-users-service-client": "/app-users-service-client/static-1.6109",
  "app-users-service-types": "/app-users-service-types/static-1.5517",
  "mini-checkout-client": "/mini-checkout-client/static-1.27857",
  "onboarding-utils": "/onboarding-utils/static-1.5862",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2143",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.29582",
  "checkout-sdk": "/checkout-sdk/static-3.24700",
  "payment-method-components": "/payment-method-components/static-1.7332",
  "touchless-buying-components": "/touchless-buying-components/static-1.6568",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3902",
  "edison-service-client-types": "/edison-service-client-types/static-1.880",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7286",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.7069",
  "audio-components": "/audio-components/static-1.6592",
  "FileManagerImages": "/FileManagerImages/static-1.38012",
  "video-components": "/video-components/static-1.14469",
  "js-cookie": "/js-cookie/static-1.18",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.20519",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.19597",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.11345",
  "crm_data": "/crm_data/static-4.93232",
  "crm-activity-creator-data": "/crm-activity-creator-data/static-1.47768",
  "crm-fe-perf": "/crm-fe-perf/static-1.23387",
  "universal-record-utils-lib": "/universal-record-utils-lib/static-1.2393",
  "calling-error-reporting": "/calling-error-reporting/static-1.31820",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11532",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.7029",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2491",
  "commerce-permissions": "/commerce-permissions/static-1.1274",
  "products-iframe-lib": "/products-iframe-lib/static-1.8942",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11307",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.11008",
  "sales-views-client-types": "/sales-views-client-types/static-1.4747",
  "data-agent-kit": "/data-agent-kit/static-1.942",
  "enrichment-settings-lib": "/enrichment-settings-lib/static-1.257",
  "policy-lib": "/policy-lib/static-1.7292",
  "bark-lib": "/bark-lib/static-1.17022",
  "browser-prettier": "/browser-prettier/static-1.11",
  "data-agent-test-utils": "/data-agent-test-utils/static-1.486",
  "react-tinymce": "/react-tinymce/static-1.56290",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.11071",
  "tinymce-config": "/tinymce-config/static-2.55416",
  "tinymce-plugins": "/tinymce-plugins/static-1.58530",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2859",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.3037",
  "user-context-client": "/user-context-client/static-1.4998",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.65",
  "urlinator": "/urlinator/static-1.5002",
  "outpost": "/outpost/static-1.4617",
  "draft-convert": "/draft-convert/static-2.84",
  "draft-extend": "/draft-extend/static-3.88",
  "draft-js": "/draft-js/static-5.90",
  "draft-plugins": "/draft-plugins/static-2.22379",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.4337",
  "ts-utils-lib": "/ts-utils-lib/static-1.640",
  "copilot-messaging": "/copilot-messaging/static-1.2426",
  "crm-export-dialog": "/crm-export-dialog/static-1.6766",
  "crm-index-ui-shimmer": "/crm-index-ui-shimmer/static-1.3002",
  "crm-view-components": "/crm-view-components/static-1.1522",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.75",
  "customer-data-associations": "/customer-data-associations/static-1.7826",
  "tasks-actions-lib": "/tasks-actions-lib/static-1.459",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15866",
  "emoji-regex": "/emoji-regex/static-1.7",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.881",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.4475",
  "company-details-components": "/company-details-components/static-1.6694",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.1041",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.16630",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3948",
  "social-insights-client-types": "/social-insights-client-types/static-1.22954",
  "utility-belt": "/utility-belt/static-1.3026",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.24241",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.8267",
  "customer-data-rte": "/customer-data-rte/static-1.33925",
  "cv-backend-services": "/cv-backend-services/static-1.1607",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6555",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5594",
  "qrcode-generator": "/qrcode-generator/static-1.80",
  "quotes-client-types": "/quotes-client-types/static-1.39195",
  "crm_universal": "/crm_universal/static-1.22746",
  "customer-data-email": "/customer-data-email/static-1.18662",
  "meetings-rte-lib": "/meetings-rte-lib/static-1.565",
  "universal-associations-select": "/universal-associations-select/static-1.11585",
  "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.10484",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.37268",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16691",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-themes": "/tinymce-themes/static-1.57386",
  "hub-http-contrib": "/hub-http-contrib/static-1.3521",
  "interframe": "/interframe/static-3.5230",
  "tinymce-data": "/tinymce-data/static-1.41501",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5690",
  "layout-dnd-components": "/layout-dnd-components/static-1.13247",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.12222",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16984",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8108",
  "company-details-service-types": "/company-details-service-types/static-1.4433",
  "segments-query-core": "/segments-query-core/static-1.1919",
  "pricing-pages-api": "/pricing-pages-api/static-1.16495",
  "stripe-connect-js": "/stripe-connect-js/static-1.83",
  "draft-content-plugins": "/draft-content-plugins/static-1.29178",
  "sequences-lib": "/sequences-lib/static-1.8808",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10656",
  "meetings-client-types": "/meetings-client-types/static-1.4079",
  "meetings-core": "/meetings-core/static-1.787",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9375",
  "ContentData": "/ContentData/static-1.69582",
  "layout-data-lib": "/layout-data-lib/static-1.10547",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8665",
  "advanced-menus-core": "/advanced-menus-core/static-1.15837",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12584",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.35227",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15836",
  "simple-menus-lib": "/simple-menus-lib/static-1.17353"
}
};
